var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "mb35 p20 brdr-1 brdr-cl-primary bg-cl-white",
      staticStyle: { "border-radius": "30px" }
    },
    [
      _c("div", { staticClass: "row mb15" }, [
        _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
          _c("h3", { staticClass: "m0 mb5" }, [
            _vm._v("\n        " + _vm._s(_vm.$t("My newsletter")) + "\n      ")
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row" },
        [
          _c("div", { staticClass: "col-xs-12" }, [
            _c("h4", [
              _vm._v(
                "\n        " + _vm._s(_vm.$t("General agreement")) + "\n      "
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "base-checkbox",
            {
              staticClass: "col-xs-12 mb25 cl-primary",
              attrs: { id: "generalAgreement" },
              on: {
                click: function($event) {
                  return _vm.edit()
                }
              },
              model: {
                value: _vm.user.isSubscribed,
                callback: function($$v) {
                  _vm.$set(_vm.user, "isSubscribed", $$v)
                },
                expression: "user.isSubscribed"
              }
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t(
                      "I want to receive a newsletter, and agree to its terms"
                    )
                  ) +
                  "\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-xs-12 col-sm-6" },
            [
              _c(
                "button-full",
                {
                  attrs: { categoryProps: _vm.categoryProps },
                  nativeOn: {
                    click: function($event) {
                      return _vm.updateNewsletter($event)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("Update my preferences")) +
                      "\n      "
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }